module.exports = __webpack_public_path__ + "img/screen_task_list.3706a6c2.jpg";